import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { LABS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/labs/")({
  component: () => <DeptContentList cfg={LABS} />,
});
